import {
	SET_WELCOME_MODAL,
	SET_CONTRACTOR_DATA,
	CHANGE_STATE,
	SET_SEARCH_ARRAY
} from '../actions/types';
import axios from "axios";
const CancelToken = axios.CancelToken;
let prevCancelReq;

export const setWelcomeModal = payload => ({
	type: SET_WELCOME_MODAL,
	payload
});

export const getContractorData = (options = {}) => {
    return async (dispatch,getState) => {
		if(prevCancelReq){
			prevCancelReq.cancel({ data: {
				isSuccess: false,
				from: "canceler"
			} });
		}
		prevCancelReq = CancelToken.source();
		let {status, pageNo, mobileNo, cb} = options;
		try {
			const payload = { status, pageNo }
			const headers = {
				headers: {
					'Content-Type': 'application/json',
					'mobileNo': mobileNo
				}
			}
			let res = await axios.post(`/marketplace/static/php/web/b2bWebsite.php?action=getContractorList`, payload, headers,
			{cancelToken: prevCancelReq.token});
			if(res.data) {
				if(dispatch) {
					dispatch({
						type: SET_CONTRACTOR_DATA,
						payload: {
							apiData : res.data
						}
					})
				}
				cb && cb(res.data);
			}
		} catch (e) {

		}
        
    };
};

export const setConnectedNumber = async (payload,options) =>  {
	const apiPayload = { 
		docid: payload.docId
	}
	const headers = {
		headers: {
			'Content-Type': 'application/json',
			'mobileNos': payload.numbers
		}
	}
	let url = `/marketplace/static/php/web/b2bWebsite.php?action=updateCheckStatusForOwnerMobile`
	let res = await axios.post(url, apiPayload, headers);
	if (res.data.isError == 0) {
		options.cb && options.cb(res) 
	} else {
		options.cb && options.cb('Failed to Save the Numbers. Please Try Again in Some Time') 
	}
}


export const setSearchDataArray = payload => ({
	type: SET_SEARCH_ARRAY,
	payload
})

export const getSearchDataArray = (options = {}) => {
	return async (dispatch,getState) => {
		if(prevCancelReq){
			prevCancelReq.cancel({ data: {
				isSuccess: false,
				from: "canceler"
			} });
		}
		prevCancelReq = CancelToken.source();
		let {text, mobileNo, pageNo, cb} = options;
		const payload = {
			searchStr: text,
			pageNo: pageNo
		}
		const headers = {
			headers: {
				'Content-Type': 'application/json',
				'mobileNo': mobileNo
			}
		}
		try {
			let res = await axios.post(`/marketplace/static/php/web/b2bWebsite.php?action=searchContractorList`, payload, headers,
			{cancelToken: prevCancelReq.token,}   
			)
			if(res.data) {
				if(res.data.status && !res.data.msg.length){
					if(dispatch) {
						dispatch({
							type: SET_SEARCH_ARRAY,
							payload: {
								data : res.data.data
							}
						})
					}
				}
				cb && cb(res.data);
			}
		} catch (e) {}
    };
};



export const changeState = payload => ({
	type: CHANGE_STATE,
	payload
});